export default __webpack_public_path__ + "static/media/pic19.840d0d0d.jpg";